import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from '@/router';

export default /*@__PURE__*/_defineComponent({
  __name: 'SubjectSettings',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    variant: "text",
    small: "",
    class: "subjectSettingsButton",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'SubjectSettings' })))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('profile.subjectSettings')) + "   ", 1),
      _createVNode(_component_v_icon, null, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("mdi-cog", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})